import { Badge } from '@app/components/badge';
import { T } from '@app/components/translation';

import style from './badge-inactive.module.scss';

export const BadgeInactive = () => (
  <Badge className={style.BadgeInactive}>
    <T
      _str="Inactive"
      _comment="Inactive badge label"
    />
  </Badge>
);
